document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-cta-popup-trigger]');
  if (trigger) {
    const dialog = document.getElementById(trigger.getAttribute('data-cta-popup-trigger'));
    if (dialog) dialog.showModal();
    return;
  }

  const closeButton = event.target.closest('[data-cta-popup-close]');
  if (closeButton) {
    const dialog = closeButton.closest('dialog');
    if (dialog) dialog.close();
    return;
  }

  const dialog = event.target.closest('dialog');
  if (dialog && event.target === dialog) {
    dialog.close();
  }
});
